import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { SearchGroupsInput } from '../../../shared/data/inputs/search-groups.input';
import { searchGroupsQuery } from '../../../shared/data/gql/query/search-groups.query';
import { SearchGroupsResponse } from '../../../shared/data/responses/search-groups.response';
import { ApolloQueryResult } from 'apollo-client';
import { Observable } from 'rxjs';
import { GetGroupResponse } from '../../../shared/data/responses/get-group.response';
import { getGroupQuery } from '../../../shared/data/gql/query/get-group.query';
import { JoinGroupResponse } from '../../../shared/data/responses/join-group.response';
import { joinGroupMutation } from '../../../shared/data/gql/mutation/join-group.mutation';
import { FetchResult } from 'apollo-link';
import { GetGroupMembersInput } from '../../../shared/data/inputs/get-group-members.input';
import { GetGroupMembersResponse } from '../../../shared/data/responses/get-group-members.response';
import { getGroupMembersQuery } from '../../../shared/data/gql/query/get-group-members.query';
import { leaveGroupMutation } from '../../../shared/data/gql/mutation/leave-group.mutation';
import { LeaveGroupResponse } from '../../../shared/data/responses/leave-group.response';
import { createGroupMutation } from '../../../shared/data/gql/mutation/create-group.mutation';
import { NewGroupInput } from '../../../shared/data/inputs/new-group.input';
import { CreateGroupResponse } from '../../../shared/data/responses/create-group.response';

@Injectable({
  providedIn: 'root'
})
export class GroupService {
  constructor(private apollo: Apollo) {}

  searchGroups(
    input: SearchGroupsInput
  ): Observable<ApolloQueryResult<SearchGroupsResponse>> {
    return this.apollo.query<SearchGroupsResponse>({
      query: searchGroupsQuery,
      variables: input
    });
  }

  getGroupByID(
    groupID: string
  ): Observable<ApolloQueryResult<GetGroupResponse>> {
    return this.apollo.query<GetGroupResponse>({
      query: getGroupQuery,
      variables: { ID: groupID }
    });
  }

  joinGroup(groupID: string): Observable<FetchResult<JoinGroupResponse>> {
    return this.apollo.mutate<JoinGroupResponse>({
      mutation: joinGroupMutation,
      variables: { groupID }
    });
  }

  leaveGroup(groupID: string): Observable<FetchResult<LeaveGroupResponse>> {
    return this.apollo.mutate<LeaveGroupResponse>({
      mutation: leaveGroupMutation,
      variables: { groupID }
    });
  }

  getGroupMembers(
    input: GetGroupMembersInput
  ): Observable<ApolloQueryResult<GetGroupMembersResponse>> {
    return this.apollo.query<GetGroupMembersResponse>({
      query: getGroupMembersQuery,
      variables: input
    });
  }

  createGroup(
    input: NewGroupInput
  ): Observable<ApolloQueryResult<CreateGroupResponse>> {
    return this.apollo.query<CreateGroupResponse>({
      query: createGroupMutation,
      variables: { input }
    });
  }
}
